import api from 'utils/api';

// custom concept overview, `task=true` embeds the grouped task tree
export const requestCustomConceptOverview = (conceptId, withTask = true) =>
  api.callGet(`admin/custom-concept/overview/${conceptId}`, {
    task: withTask,
  });

// tasks of a single custom concept group
export const requestCustomConceptTask = (taskId) =>
  api.callGet(`admin/custom-concept/task/${taskId}`);
